import { render, staticRenderFns } from "./MappingBody.vue?vue&type=template&id=671c73ec"
import script from "./MappingBody.vue?vue&type=script&lang=js"
export * from "./MappingBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports